import { faEye, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { withIconButton } from './withIconButton';
import styles from './withHintButton.module.scss';

export type HintButtonComponentProps<T> = {
  hintButtonTooltip?: {
    id: string;
    tooltip: string;
  };
  renderHintData?: () => React.ReactNode;
} & T;

export function withHintButton<T>(
  WrapperComponent: React.FC<T>,
  iconClass?: string
): React.FC<HintButtonComponentProps<T>> {
  const HintButtonComponent: React.FC<HintButtonComponentProps<T>> = (
    props
  ) => {
    const WithIconButtonComponent = useMemo(
      () => withIconButton<T>(WrapperComponent),
      []
    );

    const { hintButtonTooltip, renderHintData, ...restProps } = props;

    const [showHint, setShowHint] = useState(false);

    const triggerHintDetail = useCallback(() => {
      setShowHint((prev) => !prev);
    }, []);

    const renderHintDetail = useCallback(() => {
      return (
        <div className={styles.hintDetailBox}>
          <div className={styles.toggleDetail}>
            <Button
              variant='link'
              className={styles.closeBtn}
              onClick={triggerHintDetail}
            >
              <FontAwesomeIcon icon={faTimes} size='sm' />
            </Button>
          </div>
          <div className={styles.hintDetail}>
            {renderHintData && renderHintData()}
          </div>
        </div>
      );
    }, [renderHintData, triggerHintDetail]);

    return (
      <div className={styles.container}>
        <WithIconButtonComponent
          icon={faEye}
          iconClass={iconClass}
          buttonTooltip={hintButtonTooltip}
          onButtonClick={triggerHintDetail}
          {...(restProps as T & JSX.IntrinsicAttributes)}
        />
        {showHint && renderHintData && renderHintDetail()}
      </div>
    );
  };

  return HintButtonComponent;
}
